export const debounce = (timeoutRef, time, callback, callbackProps = []) => {
  clearTimeout(timeoutRef.current);

  timeoutRef.current = setTimeout(() => callback(...callbackProps), time);
};
